export default __webpack_public_path__ + "static/international-metric-mobile-fc7604b35de0878022f0745cfc6db97a.svg";